import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import { TratosContext } from "../../Context/TratosContext";
import TableHeadTrato from "./TableHeadTrato";
import TableBodyTratos from "./TableBodyTratos";
import {
  getComparator,
  stableSort,
} from "../../../../../Config/reuserFunctions";
import CustomTableContainer from "./CustomTableContainer";

export default function TratosTableMode() {
  const {
    tratos,
    handleSaveTrato,
    setItemsSelected,
    setIndeterminated,
    itemsSelected,
    setNewItem,
    newItem,
    tableEl,
  } = React.useContext(TratosContext);
  const [shadows, setShadows] = React.useState({
    start: "",
    end: "leftShadowTable",
  });
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("nombreTrato");

  const renderTratosSorted = React.useMemo(() => {
    return stableSort(tratos, getComparator(order, orderBy));
  }, [order, orderBy, tratos]);

  const changeClassName = React.useCallback((scrollLeft, realWidth) => {
    if (scrollLeft === 0) {
      setShadows({ start: "removeShadowTable", end: "leftShadowTable" });
      return;
    }
    if (scrollLeft === realWidth) {
      setShadows({ start: "rightShadowTable", end: "removeShadowTable" });
      return;
    }
    setShadows({ start: "rightShadowTable", end: "leftShadowTable" });
  }, []);

  const handleOnScroll = (ev) => {
    const { scrollLeft, scrollWidth, clientWidth } = ev.target;
    const realWidth = scrollWidth - clientWidth;
    changeClassName(scrollLeft, realWidth);
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelect = (checked, item) => {
    const items = [...itemsSelected];
    if (checked) items.push(item);
    if (!checked) {
      const indx = items.findIndex((elm) => elm._id === item._id);
      items.splice(indx, 1);
    }
    setItemsSelected(items);
    //revisar el checkAll
    if (items.length > 0 && items.length !== tratos.length) {
      setIndeterminated(true);
      return;
    }
    setIndeterminated(false);
  };

  const handleCheckAll = (checked) => {
    setIndeterminated(false);
    if (checked) {
      setItemsSelected(tratos);
      return;
    }
    setItemsSelected([]);
  };

  return (
    <Paper variant="outlined">
      <CustomTableContainer
        tableRef={tableEl}
        onScroll={handleOnScroll}
        onFocusInput={() =>
          newItem &&
          setNewItem((st) => {
            const { focusOn, ...state } = st;
            return state;
          })
        }
      >
        <form
          id="form-trato-table"
          onSubmit={(e) => handleSaveTrato(e)}
          style={{ height: "10px" }}
        >
          <Table stickyHeader size="small">
            <TableHeadTrato
              handleSort={handleSort}
              order={order}
              orderBy={orderBy}
              handleCheckAll={handleCheckAll}
            />
            <TableBodyTratos
              shadows={shadows}
              tratos={renderTratosSorted}
              handleSelect={handleSelect}
            />
          </Table>
        </form>
      </CustomTableContainer>
    </Paper>
  );
}
